import React, { useState, useRef } from 'react';
import { AdContainer } from './styles';

const LOGIN_PAGE_ADS_URL = 'https://www.podium.com/login-module';
const MIN_AD_WIDTH = 450;

export default function LoginPageAds() {
  const [slideIn, setSlideIn] = useState(false);
  const adContainer = useRef();

  const onIframeLoad = () => {
    const width = window.innerWidth;
    if (width > MIN_AD_WIDTH) {
      adContainer.current.style.display = 'flex';
      setTimeout(() => setSlideIn(true), 300);
    }
  };

  if (window.location.href.includes('oauth')) return null;

  return (
    <AdContainer slideIn={slideIn} ref={adContainer}>
      <iframe
        title="login-page-ads"
        src={LOGIN_PAGE_ADS_URL}
        style={{ width: '100%', height: '100%', border: 'none' }}
        onLoad={onIframeLoad}
      />
    </AdContainer>
  );
}
